<div class="row g-4 g-md-5">
  <div class="col-12 mb-n3">
    <mwe-address
      (onItemClick)="actionHandler($event)"
      [addressIdx]="addressIdx()"
      [address]="address()"
      [allDropdownItems]="dropdownItems()"
      [dropdownType]="dropdownType()"
      [featuredBtnIds]="featuredBtnIds()"
      [isAddressDetailsBodyVisible]="isDetailsState()"
      [productCategories]="productCategories()"
      [singleMarker]="products()?.length === 1"
      [textNodeType]="headlineService.getHeadline(1)"
      [isEndedContract]="hasContractEnded()"
      dropdownEditKey="products.addresGroupItems.label"
    />
  </div>
  <div class="col-12">
    @if (hasUnpaidInvoices() && !hasContractEnded()) {
      <div class="mb-4 mb-md-5">
        <mwe-products-group-unpaid-invoice-notification
          [addressProducts]="{ address: address(), products: products() }"
          [unpaidInvoices]="unpaidInvoices()"
        />
      </div>
    }
    <div class="row g-4 g-md-5">
      @for (p of products(); track $index) {
        <mwe-product-card
          [checkIfFernwaermeIsActive]="checkIfFernwaermeIsActive()"
          [groupProducts]="products()"
          [product]="p"
          [showCompanyCorrelation]="showCompanyCorrelation()"
          [state]="state()"
          [unpaidInvoices]="getUnpaidInvoice(p)"
          class="col-12 col-md-6 mh-100"
          [useClickableCardStyle]="isClickableCard()"
        />
      }
    </div>
  </div>
</div>
